<template>
  <div class="pager">
    <ActionButton
      class="pager__btn pager__btn--prev"
      :text="prevLabel"
      :outlined="true"
      :borderColor="'#E5E7EB'"
      :disabled="!canPrev"
      @click="onPrev"
    />
    <ActionButton
      class="pager__btn pager__btn--next"
      :text="nextLabel"
      :color="primaryColor"
      :disabled="!canNext"
      @click="onNext"
    />
  </div>
</template>

<script>
import ActionButton from '@/components/widgets/ActionButton.vue'

export default {
  name: 'ViewNavButtons',
  components: { ActionButton },
  props: {
    prevText: { type: String, default: '' },
    nextText: { type: String, default: '' },
    primaryColor: { type: String, default: '#2A8A1B' },
    prevTo: { type: [String, Object], default: null },
    nextTo: { type: [String, Object], default: null },
  },
  computed: {
    canPrev() { return !!this.prevTo },
    canNext() { return !!this.nextTo },
    // По ТЗ 03.09.2026: локализуем «Назад / Далее» из nav.back / nav.next,
    // если prop не передан явно (обратная совместимость).
    prevLabel() { return this.prevText || this.$t('nav.back') },
    nextLabel() { return this.nextText || this.$t('nav.next') },
  },
  methods: {
    onPrev() { if (this.canPrev) this.$router.push(this.prevTo) },
    onNext() { if (this.canNext) this.$router.push(this.nextTo) },
  }
}
</script>

<style scoped>
/*
 * Навигационные кнопки Назад/Далее — единый стиль для всех страниц.
 * По ТЗ (встреча 27.08.2026, п.14): низ страницы, единая стилистика.
 * Обёртка прозрачная — фон/тени задаёт родительский контейнер (например
 * фикс-панель футера в PersonnelListView).
 */
.pager {
  display: flex;
  gap: 14px;
  align-items: center;
  justify-content: center;
  margin: 28px auto 24px;
  width: fit-content;
  max-width: 100%;
}
.pager__btn {
  min-width: 190px;
  height: 54px;
  border-radius: 12px !important;
  font-size: 16px;
}
/* «Назад» — мягкая tonal-кнопка (перекрываем inline outlined-стили ActionButton) */
.pager__btn--prev {
  background: #F3F4F6 !important;
  color: #374151 !important;
  border: 1px solid #E5E7EB !important;
  font-weight: 600;
  transition: background .15s, border-color .15s, color .15s;
}
.pager__btn--prev:hover {
  background: #E5E7EB !important;
  border-color: #D1D5DB !important;
  color: #111827 !important;
}
.pager__btn--prev:disabled {
  background: #F9FAFB !important;
  color: #9CA3AF !important;
  border-color: #F1F3F5 !important;
}
@media (max-width: 640px) {
  .pager { gap: 10px; margin: 20px auto; }
  .pager__btn { min-width: 140px; height: 46px; font-size: 15px; }
}
</style>
